export function isEditorContentEmpty(val) {
  if (val == null || val === '') return true;
  const str = String(val).trim();
  return str === '' || str === '<p><br></p>' || str === '<p></p>';
}

export function normalizeEmptyContent(val) {
  return isEditorContentEmpty(val) ? '' : val;
}
